import { GetServerSideProps } from 'next';
import { NavBarContent } from '@/components/Navbar';
import { api, site } from '@/services/api';
import InstitutionalPage from '@/components/Institutional/InstitutionalPage';
import { FeaturedNewsApi } from '@/shared/types/home.types';
import getConcurrentPromises from '@/utils/getConcurrentPromises';
import Layout from '@/components/Layout';
import { InstitutionalProps } from '../privacidade';

interface NavBarContentData {
  data: NavBarContent;
}

export default function Privacy({ institutionalData, navBarData, ssr, schema }: InstitutionalProps) {
  const { data } = institutionalData;
  const { cabecalho, conteudo } = data;

  return (
    <Layout layoutData={{ segmentacoes: [], tagsData: ssr, navBarData, schema }}>
      <InstitutionalPage
        text={conteudo}
        title="Programa de Integridade"
        headerImg={{ url: cabecalho.imagem.url, blurhash: cabecalho.imagem.blurhash, srcset: cabecalho.imagem.srcset }}
        breadcrumbs={[]}
        type="integridade"
      />
    </Layout>
  );
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { host } = context.req.headers;

  const mainReq = { promise: site.get<FeaturedNewsApi>(`/programa-de-integridade/`), link: `/programa-de-integridade/` };
  const responseMenuReq = { promise: api.get<NavBarContentData>(`/componentes/menu/`), link: `/componentes/menu/` };

  const { promiseData, data, statusCode } = await getConcurrentPromises({
    mainPromise: mainReq,
    navBarPromise: responseMenuReq,
    host,
  });

  if (data.redirect || data.notFound) return data;

  const navBarData: NavBarContentData = promiseData[responseMenuReq.link].data.data;
  const { ssr, headers, schema } = data;

  context.res.setHeader('Cache-Control', headers['Cache-control']);
  context.res.setHeader('Expires', headers.Expires);
  context.res.statusCode = statusCode;

  const institutionalData = data;

  return {
    props: {
      institutionalData,
      navBarData,
      ssr,
      headers,
      schema,
    },
  };
};
